import type { OptionsDocument } from 'paintscout'
import { getPayrixCredentials } from '../getPayrixCredentials/get-payrix-credentials'

export function getPaymentPortalLink(
  providerDetails: Record<string, any> | undefined,
  options: OptionsDocument
): string | undefined {
  if (!providerDetails) return undefined

  // Payrix: nested shape stored on the payment ({ payrix: { txnId } }) or the raw shape stored on
  // the activity (PayrixProviderDetails.paymentId is the txn id).
  const payrixTxnId = providerDetails.payrix?.txnId ?? providerDetails.paymentId
  if (payrixTxnId) {
    const { portalUrl } = getPayrixCredentials(options)
    return `${portalUrl}/payments/profile/${payrixTxnId}/customer`
  }

  // Stripe: nested shape stored on the payment ({ stripe: { paymentIntentId } }) or the raw shape
  // stored on the activity (the PaymentIntent's id, e.g. "pi_...").
  const stripePaymentIntentId =
    providerDetails.stripe?.paymentIntentId ??
    (typeof providerDetails.id === 'string' && providerDetails.id.startsWith('pi_') ? providerDetails.id : undefined)
  if (stripePaymentIntentId) {
    return `https://dashboard.stripe.com/payments/${stripePaymentIntentId}`
  }

  return undefined
}
